'use strict';

// Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function(fn) {
  return function() {
    var
      args = Array.prototype.slice.call(arguments, 0),
      newFunc = function() {
        return fn.apply(null, args);
      };
    setTimeout(newFunc, 0);
  };
};



//////////////////
// WEBPACK FOOTER
// ./~/httpplease/lib/utils/delay.js
// module id = 71
// module chunks = 35783957827783 55213770944713 173894859265406